import KAllTrucksMap from "../maps/KAllTrucksMap";
import KBaseMapDialog from "@/components/Maps/KBaseMapDialog";
import { VCol, VSwitch } from "vuetify/lib";

export default KBaseMapDialog.extend( {
	name: "KAllTrucksMapDialog",

	props: {
		storeModuleName: {
			default: "all-trucks-map",
			type: String
		},

		title: {
			...KBaseMapDialog.options.props.title,
			default: "Trucks Map"
		}
	},

	computed: {
		moduleRegistered() {
			return this.$store.state.hasOwnProperty( this.storeModuleName );
		},

		history: {
			get() {
				if ( this.moduleRegistered ) {
					return this.$store.state[this.storeModuleName].history;
				}

				return false;
			},

			set( val ) {
				if ( this.moduleRegistered ) {
					this.$store.dispatch( `${this.storeModuleName}/setHistory`, val );
				}
			}
		},

		sidebar: {
			get() {
				if ( this.moduleRegistered ) {
					return this.$store.state[this.storeModuleName].sidebar;
				}

				return false;
			},

			set( val ) {
				if ( this.moduleRegistered ) {
					this.$store.dispatch( `${this.storeModuleName}/setSidebar`, val );
				}
			}
		},

		traffic: {
			get() {
				if ( this.moduleRegistered ) {
					return this.$store.state[this.storeModuleName].traffic;
				}

				return false;
			},

			set( val ) {
				if ( this.moduleRegistered ) {
					this.$store.dispatch( `${this.storeModuleName}/setTraffic`, val );
				}
			}
		}
	},

	render() {
		return <KBaseMapDialog
			attrs={{ ...this.$props }}
			on={this.$listeners}
			scopedSlots={this.$scopedSlots}
		>
			{this.genActivator()}

			<KAllTrucksMap
				storeModuleName={this.storeModuleName}
			></KAllTrucksMap>

			<template slot="options">
				<VCol class="py-0">
					<VSwitch
						color="accent"
						inset
						label="Trucks Sidebar"
						prependIcon="local_shipping"
						vModel={this.sidebar}
					></VSwitch>
				</VCol>

				<VCol class="py-0">
					<VSwitch
						color="accent"
						inset
						label="History"
						prependIcon="history"
						vModel={this.history}
					></VSwitch>
				</VCol>

				<VCol class="py-0">
					<VSwitch
						color="accent"
						inset
						label="Traffic"
						prependIcon="traffic"
						vModel={this.traffic}
					></VSwitch>
				</VCol>
			</template>
		</KBaseMapDialog>;
	}
} );
